<template>
  <div>
    <shop-header :store-id="storeid" />
    <div class="bg-white">
      <div class="row m-4 justify-content-center">
        <div class="col-lg-9 bg-white py-4">
          <div class="p-4">
            <div class="row">
              <div class="col-sm-12 text-center">
                <h1 class="fw-normal">{{displayModel.orderState}}</h1>
                <div class="alert alert-primary" role="alert" v-if="createUserForGuest">
                  <span>Registration instruction has been emailed to you, please follow the instruction on the email to finalise your registration.</span>
                </div>
              </div>
            </div>
            <div class="row">
              <tracking-component
                @update-status="u=>updateStatus(u)"
                :order="trackingOrder"
                :store="store"
              ></tracking-component>
            </div>
            <div class="row order-history-div">
              <div class="col-sm-12 text-center">
                <button
                  v-show="isguest===false"
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="viewHistory"
                >View my order history</button>
                <button
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="continueShopping"
                >Continue Ordering</button>
                <poweredby />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/shop/Checkout/CompleteOrder.js";
import TrackingComponent from "../../user/partials/trackingComponent";
import ShopHeader from "../partials/shopheader";
import poweredby from "../../shared/poweredby";
export default {
  components: { ShopHeader, poweredby, TrackingComponent },
  props: {
    storeid: {
      type: String,
      default: ""
    },
    orderid: {
      type: String,
      default: ""
    },
    userid: {
      type: String,
      default: ""
    },
    isguest: {
      type: Boolean,
      default: false
    },
    createUserForGuest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      store: {},
      trackingOrder: {},
      minutes: 0,
      displayModel: {
        orderState: "Order Sent!",
        orderMode: "Pickup",
        status: -1
      }
    };
  },
  beforeDestroy() {
    this.beforeDestroyComponent();
  },
  computed: {
    ...shared.computed
  },
  watch: {
    ...shared.watch
  },
  created() {
    this.createdComponent();
  },
  mounted() {
    this.mountedComponent(this);
  },
  methods: {
    ...shared.methods
  }
};
</script>
